import React from 'react'
import styled from 'styled-components'
import { ManageLeadsFirst } from '../../Components/Telesales/Telesaleleads/Telesalemanageleads/ManageLeadsFirst'

export const ManageLeadsComponent = () => {
  return (
    <Main>
        <ManageLeadsFirst/>
    </Main>
  )
}


const Main = styled.div`
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  min-height: 100vh;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`